import { Badge } from './ui';

/**
 * Marks a rehearsal, everywhere one can appear.
 *
 * Test events are deliberately visible to the whole club rather than hidden from
 * members — hiding them would mean the member-side flows (the RSVP form, the
 * scorecard, the reveal) could never be tested against a real member's account,
 * which is most of what there is to test. The badge is what keeps that honest:
 * anyone who lands on one should be able to tell at a glance that the night
 * isn't real, without reading the fine print.
 */
export function TestEventBadge({ isTest }: { isTest?: boolean | null }) {
  if (!isTest) return null;
  return <Badge tone="warning">Test event</Badge>;
}
